
import {Fetch} from "../../utils/storage"
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import   {Api} from "../../utils/api"
import {ParseTime} from "../../utils/time"
import NotFound from '../../components/NotFound'

export default {
name: 'blank',
components: {
Checker,
CheckerItem,
XButton,
NotFound
},
filters: {
},
data () {
return {
OrderList:[],
InvoiceList:[],
OrderIDs:[],
ApplyReq:{},
UserID:0,
Limit:999,
Page:1,
}
},
created () {
this.UserID = Fetch("ID")
this.fetchOrderList()
},
methods : {
ParseTime,
async handleGoDetail(fpqqlsh) {
let _this = this
let res = await Api('GetInvoiceInfo',{
fpqqlsh
})
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="font-size:20px">即将跳转发票详情页面</p>
<p style="font-size:20px;margin-bottom: 4px">发票查看码：<span style="color:red;font-weight:bold">${res.data.ShareCode}</span>
</p>`,
confirmText:"确认",
cancelText:"取消",
async onConfirm(){
try {
window.location = res.data.ShareUrl
}catch(err) {
console.log(err)
}
}
})

},
async fetchOrderList() {
let res = await Api('GetMyInvoiceList',{
Data:{
},
Limit:this.Limit,
Order:'updated_at desc',
Preloads:[
{Column:'Orders'},
{Column:'Orders.OrderInfo'},
]
})
this.InvoiceList = res.data.List || []

},
handleOrderTicket(id) {
this.$router.push(`/order/ticket/detail/${id}`)
},
async handleOrderLive(subID) {
try {
let res = await Api('GetSubMeetingList',{
Data:{
ID:subID,
}
})

switch(res.data.List[0].LiveResourceType){
case 'xiaoetong':
window.location.href = `https://zhibo.fuyouhuiyi.com/detail/${res.data.List[0].LiveResourceID}/4`
break;
case 'xiaoetong-zhuanlan':
window.location.href = `https://zhibo.fuyouhuiyi.com/detail/${res.data.List[0].LiveResourceID}/6`
break;
case 'tencent':
window.location.href = `http://enroll.admin.fuyouhuiyi.com/#/download/notice/file`
break;
case 'zoom':
window.location.href = `http://enroll.admin.fuyouhuiyi.com/#/download/notice/file`
break;
case 'third-part':
window.location.href = `${res.data.List[0].LiveResourceID}`
break;
}
}
catch (err) {
this.$vux.toast.show({
text: '获取直播地址错误：'+err.message,
type: 'text',
width: '3rem'
})

}
},
parseMeetingTime(str) {
let timeArr = str.split('----')
if (timeArr.length !== 2) {
return ''
}
let start = ParseTime(timeArr[0],'{y}-{m}-{d}')
let end = ParseTime(timeArr[1],'{y}-{m}-{d}')
return `${start} 至 ${end}`
},
async handleSubmit() {
if (this.OrderIDs.length < 1) {
this.$vux.toast.show({
text: '请选择要开取的发票',
type: 'text',
width: '3rem'
})
return
}
let orders = this.OrderList.filter(item => {
return this.OrderIDs.indexOf(item.ID) > -1
})
if (new Set(orders.map(item => {
return item.MeetingID
})).size > 1) {
this.$vux.toast.show({
text: '不同会议的订单不可合开',
type: 'text',
width: '3rem'
})
return
}
let meetingID = orders[0].MeetingID
this.$router.push(`/order/invoice/apply-multiple?orderIDs=${JSON.stringify(this.OrderIDs)}&MeetingID=${meetingID}`)

},
async clearSelect() {
this.OrderIDs = []
},
getItemInfo(applyReq, field) {
let reqData = JSON.parse(applyReq.ReqData)
switch (field) {

case 'title':
return applyReq.Orders[0] ? applyReq.Orders[0].OrderInfo.MeetingTitle : '暂无'
case 'taxNumber':
return reqData.GMF_MC || '暂无'
case 'taxTitle':
return reqData.GMF_NSRSBH || '暂无'
case 'email':
return applyReq.Email || '暂无'
}
}
}
}
